import * as moment from "moment";
import { IPrecatorioCreateOrUpdateOfficerDto } from '../interfaces/IPrecatorioCreateNew';
import { PrecatorioStatus } from '../interfaces/PrecatorioStatus';
import { PrecatorioClassification } from '../interfaces/UserInterface';

export const EmptyNewPrecatorioRequest: IPrecatorioCreateOrUpdateOfficerDto = {
  principal: 0,
  interest: 0,
  baseDate: moment(),
  issueDate: moment(),
  status: PrecatorioStatus.Precificando,
  classification: PrecatorioClassification.Precatorio,
  natureId: null,
  correctionTypeId:null,
  courtId: null,
  cpfCnpj: null,
  active: false,
  courtTypeId: null,
  precatorioExpeditionType: null,
  birthDate: undefined,
  createdDate: undefined,
  tradeId: null,
  reducedPercentLender: 1,
  isReducedPercentLender: false,
  preferredInstallment: null
};


// WEBPACK FOOTER //
// ./src/services/mapper/EmptyNewPrecatorioRequest.ts